import React, { useMemo } from 'react';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import styled from 'styled-components';

const PosicoesFrotaMapFilter = ({
  regionOptions = [],
  frotaOptions = [],
  selectedRegion,
  selectedFrotaSearch,
  onRegionChange,
  onFrotaSearchChange
}) => {
  const showRegionFilter = false;

  const filters = useMemo(() => ([
    ...(showRegionFilter ? [{
      id: 'Regiao',
      type: 'searchSelect',
      label: 'Região',
      placeholder: 'Filtrar por região',
      options: regionOptions,
      isClearable: false
    }] : []),
    {
      id: 'NumeroFrota',
      type: 'searchSelect',
      label: 'Número da Frota',
      placeholder: 'Buscar por frota',
      options: frotaOptions
    }
  ]), [frotaOptions, regionOptions, showRegionFilter]);

  const values = useMemo(() => ({
    Regiao: selectedRegion || null,
    NumeroFrota: frotaOptions.find(option => option.value === selectedFrotaSearch) || ''
  }), [frotaOptions, selectedFrotaSearch, selectedRegion]);

  const handleApply = nextValues => {
    onRegionChange?.(nextValues?.Regiao || null);
    onFrotaSearchChange?.(nextValues?.NumeroFrota?.value || '');
  };

  return (
    <MapFilterPanelWrap>
      <FilterPanel
        filters={filters}
        values={values}
        onApply={handleApply}
        title="Filtros do Mapa Frotas"
        loading={false}
        defaultCollapsed={true}
        collapseOnSearch={true}
      />
    </MapFilterPanelWrap>
  );
};

const MapFilterPanelWrap = styled.div`
  .filter-panel-searchselect {
    max-width: 520px;
  }
`;

export default PosicoesFrotaMapFilter;
